const KEY_PREFIX = `ancare-business.`;

const USER_DATA_KEYS = {
  potentialCustomerColumnLayout: KEY_PREFIX + 'potentialCustomerColumnLayout', // 潜在客户表格宽度布局
  formalCustomerColumnLayout: KEY_PREFIX + 'formalCustomerColumnLayout', // 正式客户表格宽度布局
};

const KEYS = {
  ...USER_DATA_KEYS
};

function getItem(k) {
  let value = localStorage.getItem(k);

  try {
    value = JSON.parse(value);
  } catch (e) {

  }

  return value;
}

function setItem(k, v) {
  localStorage.setItem(k, JSON.stringify(v));
}

function removeItem(k) {
  localStorage.removeItem(k);
}

function clearAll() {
  localStorage.clear();
}

function clearUserData() {
  Object.values(USER_DATA_KEYS).forEach(k => {
    removeItem(k);
  })
}

export default {
  KEYS,
  getItem,
  setItem,
  removeItem,
  clearAll,
  clearUserData
};
